import { observer, useLocalStore } from 'mobx-react';
import * as React from 'react';
import { OcDataview } from '../../comps/OcDataview';
import { OcDataviewFiltering } from '../../comps/OcDataviewFiltering';
import { PleaseWait } from '../../comps/PleaseWait';
import { Submenu } from '../../comps/Submenu';
import { ICoupon, IEntityStore } from '../../main/entities';
import { useNoSubmenu } from '../../mainpanel/useSubmenu';
import { mgColumnFactory, MgColumnist } from '../../mg/table/MgColumn';
import { MgEntityEditDialog } from '../../mg/table/MgEntityEditDialog';
import { useBooleanStateAgg } from '../../mg/useStateAgg';
import { toasterSvc } from '../../services/ToasterSvc';
import { DataviewStore } from '../../stores/DataviewStore';
import { useOmnistore } from '../../stores/Omnistore';

const columnist = mgColumnFactory.createColumnist([
	'/id',
	'*name',
	'isDeleted :bool',
	'onceOnly :bool',
	'oncePerTemplate :bool',
]);

const dataviewStore = DataviewStore.create({
	id: 'CouponPage',
	orgColumns: columnist.descriptors,
	filtering: [{columns: ['name'], value: ''}],
	sorting: {column: 'name'},
});

interface IAdmCouponDialogProps {
	columnist: MgColumnist
	entity?: object
	onClose() : void
	repo: IEntityStore<ICoupon>
}

const AdmCouponDialog = observer(function AdmCouponDialog(props: IAdmCouponDialogProps) {
	const {columnist, entity, onClose, repo} = props;
	const editable = useLocalStore(() => columnist.newEntity(entity)) as Record<string, string>;
	const omnistore = useOmnistore();
	function finish(entity: Record<string, any>) : void {
		if (!entity) return onClose();
		omnistore.communicator.doPost('PutCoupon', {...editable, id: editable.id || null})
			.then(toasterSvc.handleResponse('saved'))
			.then(r => {
				if (r.outputList) {
					repo.fetch('DIRECT');
					onClose();
				}
			});
	}
	return <MgEntityEditDialog
		columnist={columnist}
		extras={columnist.newExtras(editable, {})}
		entity={editable}
		baseName="AdmCouponDialog"
		finish={finish}
	/>;
});

export const AdmCouponPage = observer(function AdmCouponPage() {
	const showDialogAgg = useBooleanStateAgg();
	const repo = useOmnistore().entityManagerStore.byStoreId('Coupon') as IEntityStore<ICoupon>;
	React.useEffect(() => {
		repo.fetch();
	}, []);
	useNoSubmenu();
	const onDialogClose = () => {
		dataviewStore.rowClick(0);
		showDialogAgg.falseHandler();
	};
	const selectedEntity = repo.byId(dataviewStore.selectedEntityId);
	return !repo.etag ? <PleaseWait/> : <>
		<Submenu>
			<OcDataviewFiltering state={dataviewStore} repo={repo}/>
			{{name: 'create', onClick: showDialogAgg.trueHandler}}
			---
		</Submenu>
		<OcDataview state={dataviewStore} repo={repo}/>
		{!selectedEntity && !showDialogAgg.value ? null : <AdmCouponDialog entity={selectedEntity} columnist={columnist} onClose={onDialogClose} repo={repo}/>}
	</>;
});
